<template>
  <div class="step-business-wide">
    <div class="step-hd">
      <h2>经营信息</h2>
      <p>多为选填，完善后平台可更精准匹配服务，确认无误即可提交</p>
    </div>
    <div class="step-layout step-layout-2equal">
      <div class="col-stack gap-lg">
        <div class="card">
          <div class="card-hd"><h3>办公场所</h3></div>
          <div class="card-bd">
            <div class="g2">
              <div class="fld">
                <label class="fld-lbl"><span class="req">*</span>场所类型</label>
                <select v-model="form.officeType" class="fld-sel">
                  <option value="">请选择</option>
                  <option>自有办公场所</option>
                  <option>租赁办公场所</option>
                  <option>共享办公场所</option>
                  <option>自有工厂/仓库</option>
                  <option>租赁工厂/仓库</option>
                  <option>无固定场所</option>
                </select>
              </div>
              <div class="fld">
                <label class="fld-lbl">面积 <span class="opt">选填</span></label>
                <input v-model="form.officeArea" class="fld-in mono" placeholder="m²">
              </div>
              <div class="fld span2">
                <label class="fld-lbl"><span class="req">*</span>办公地址</label>
                <input v-model="form.officeAddress" class="fld-in" placeholder="实际经营地址，可与注册地址不同">
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-hd"><h3>人员规模</h3></div>
          <div class="card-bd">
            <div class="g2" style="grid-template-columns:1fr 1fr">
              <div class="fld" style="margin-bottom:0">
                <label class="fld-lbl"><span class="req">*</span>公司总人数</label>
                <input v-model="form.officeEmployeeTotal" class="fld-in mono" placeholder="人">
              </div>
              <div class="fld" style="margin-bottom:0">
                <label class="fld-lbl"><span class="req">*</span>缴纳社保人数</label>
                <input v-model="form.officeSocialSecurityCount" class="fld-in mono" placeholder="人">
              </div>
            </div>
            <div class="fld-hint" style="margin-top:10px">社保人数须与实际缴纳情况一致，用于平台风控评估</div>
          </div>
        </div>
        <div class="card">
          <div class="card-hd"><h3>服务需求</h3><span class="card-hd-extra">选填</span></div>
          <div class="card-bd">
            <div class="tags">
              <span
                v-for="tag in serviceOptions"
                :key="tag"
                class="tag-chip"
                :class="{ on: form.serviceRequirements.includes(tag) }"
                @click="toggleTag(tag)"
              >{{ tag }}</span>
            </div>
            <div class="fld" style="margin-top:16px;margin-bottom:0">
              <label class="fld-lbl">其他说明 <span class="opt">选填</span></label>
              <textarea v-model="form.serviceRemark" class="fld-in" rows="2" placeholder="如固定线路整车直发、节假日运力保障等" />
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-hd">
          <h3>常发线路</h3>
          <span class="card-hd-extra">选填，最多 10 条</span>
        </div>
        <div class="card-bd">
          <div class="rt">
            <div class="rt-h"><div>始发</div><div>目的</div><div>货物</div><div>月运量</div><div /></div>
            <div v-for="(row, idx) in form.commonRoutes" :key="idx" class="rt-r">
              <input v-model="row.from" class="fld-in" placeholder="始发">
              <input v-model="row.to" class="fld-in" placeholder="目的">
              <input v-model="row.goods" class="fld-in" placeholder="货物">
              <select v-model="row.volume" class="fld-sel">
                <option>50吨以下</option>
                <option>50-200吨</option>
                <option>200-500吨</option>
                <option>500吨以上</option>
              </select>
              <button type="button" class="rt-del" @click="delRt(idx)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></svg>
              </button>
            </div>
          </div>
          <button type="button" class="btn btn-ghost btn-sm" style="margin-top:12px" @click="addRt">+ 添加线路</button>
          <div class="hint hint-info" style="margin-top:20px">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            ><circle cx="12" cy="12" r="9" /><path d="M12 8v4M12 16h.01" /></svg>
            <span>提交后平台将在 1 个工作日内完成审核，结果短信通知管理员手机号。</span>
          </div>
        </div>
      </div>
    </div>
    <div class="step-ft">
      <button type="button" class="btn step-btn-sec" @click="$emit('prev')">← 上一步</button>
      <button type="button" class="btn btn-pri btn-lg" style="padding:0 36px" :disabled="submitting" @click="submit">确认提交</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepBusiness",
  props: {
    value: { type: Object, required: true },
    submitting: { type: Boolean, default: false }
  },
  data() {
    return {
      serviceOptions: [
        "运费垫付", "货运保险", "账期支持", "回单电子化",
        "油卡 / ETC", "冷链运力", "大件运输", "专属客服"
      ]
    };
  },
  computed: {
    form: {
      get() { return this.value; },
      set(v) { this.$emit("input", v); }
    }
  },
  methods: {
    toggleTag(tag) {
      const list = this.form.serviceRequirements || [];
      const i = list.indexOf(tag);
      if (i >= 0) list.splice(i, 1);
      else list.push(tag);
      this.$set(this.form, "serviceRequirements", list);
      this.$emit("saved");
    },
    addRt() {
      if ((this.form.commonRoutes || []).length >= 10) return;
      this.form.commonRoutes.push({ from: "", to: "", goods: "", volume: "50吨以下" });
    },
    delRt(idx) {
      if ((this.form.commonRoutes || []).length <= 1) return;
      this.form.commonRoutes.splice(idx, 1);
    },
    submit() {
      const f = this.form;
      if (!f.officeType) return this.$message.warning("请选择场所类型");
      if (!f.officeAddress) return this.$message.warning("请填写办公地址");
      if (!f.officeEmployeeTotal) return this.$message.warning("请填写公司总人数");
      if (!f.officeSocialSecurityCount) return this.$message.warning("请填写缴纳社保人数");
      this.$emit("submit");
    }
  }
};
</script>
